import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ELEMENT_PARAGRAPH } from '@udecode/slate-plugins';

const StyledParagraph = styled.p`
  font-family: 'Backpack', sans-serif;
  font-size: 14px;
  line-height: 17px;
  color: #17181a;
`;

export const Paragraph = ({ element, attributes, children, className }) => (
  <StyledParagraph {...attributes} className={className} style={element.style}>
    {children}
  </StyledParagraph>
);

Paragraph.propTypes = {
  children: PropTypes.node,
  attributes: PropTypes.elementType,
  element: PropTypes.shape({
    style: PropTypes.string,
  }).isRequired,
  styles: PropTypes.object,
  className: PropTypes.string,
};

Paragraph.defaultProps = {
  children: null,
  attributes: [],
  styles: undefined,
  className: '',
};

const defaultParagraph = {
  p: {
    component: Paragraph,
    type: ELEMENT_PARAGRAPH,
    rootProps: {
      className: 'slate-p',
    },
  },
};

export default defaultParagraph;
